module.exports = __webpack_public_path__ + "static/media/gift.dd2710af.svg";